import { __extends } from "tslib";
import { BaseAdapter } from '../core/adapters/base-adapter';
import { EXPANSION_PANEL_CONSTANTS } from '../expansion-panel';
import { elementParents } from '@tyler-components-web/core';
var AccordionAdapter = /** @class */ (function (_super) {
    __extends(AccordionAdapter, _super);
    function AccordionAdapter(component) {
        return _super.call(this, component) || this;
    }
    /**
     * Gets the `<tcw-accordion>` host element.
     * @returns An instance of the `AccordionComponent`.
     */
    AccordionAdapter.prototype.getHostElement = function () {
        return this._component;
    };
    /**
     * Determines if the given expansion panel element is nested within another expansion panel.
     * @param element The expansion panel element to test.
     */
    AccordionAdapter.prototype.isNestedPanel = function (element) {
        if (!element || !this._component.contains(element)) {
            return false;
        }
        var parents = elementParents(element, this._component);
        return parents.some(function (el) { return el.tagName.toLocaleLowerCase() === EXPANSION_PANEL_CONSTANTS.elementName; });
    };
    /**
     * Finds all child `<tcw-expansion-panel>` components within the host element.
     * @returns An array of `ExpansionPanelComponent` child instances.
     */
    AccordionAdapter.prototype.getChildPanels = function (selector) {
        if (selector) {
            return Array.from(this._component.querySelectorAll(selector));
        }
        else {
            var children = Array.from(this._component.children);
            return children.filter(function (child) { return child.tagName.toLocaleLowerCase() === EXPANSION_PANEL_CONSTANTS.elementName; });
        }
    };
    /**
     * Adds an event listener to the provided element.
     * @param event The event name.
     * @param callback The event callback.
     * @param element The element to emit the event from.
     * @param [bubbles] Whether the event bubbles or not.
     */
    AccordionAdapter.prototype.addEventListener = function (event, callback, element, bubbles) {
        element.addEventListener(event, callback, bubbles || false);
    };
    /**
     * Removes an event listener from the provided element.
     * @param event The event name.
     * @param callback The event callback.
     * @param element The event to remove the event from.
     */
    AccordionAdapter.prototype.removeEventListener = function (event, callback, element) {
        element.removeEventListener(event, callback);
    };
    return AccordionAdapter;
}(BaseAdapter));
export { AccordionAdapter };
